import Environment from "services/environment/index";
import useOpenApiCall from "hooks/useOpenApiCall";

const env = Environment.getEnv();

const { apiCall } = useOpenApiCall();
export const postFormData = (payload) =>
  apiCall({
    url: env.talkToExpertUrl,
    method: "POST",
    data: payload,
    headers: env.talkToExpertHeaders,
  })
    .then((res) => res)
    .catch((err) => {
      throw err;
    });
